import { ACCESS_LEVELS } from '@/lib/consts.js'
import { __t } from '@/lib/helpers.js'
import { store } from '@/store/index.js'
import { resolveBooksyPayEntryRedirect, BOOKSY_PAY_ENTRY_TARGETS } from '@/composables/payments/booksy-pay/entry.ts'
import {
  ONLINE_BOOKING_ENTRY_SOURCES,
  ONLINE_BOOKING_ENTRY_SOURCE_QUERY_KEY,
} from '@/components/settings/online-booking/consts.js'
import { SPLASH_SCREENS_VIEWS } from '@/views/business/settings/splash-screens/const.js'

import Details from './details.js'
import Services from './services.js'
import AdvancedOptions from './advanced-options.js'
import Subscription from './subscription.js'
import Personal from './personal.js'
import PartnerApps from './partner-apps.js'
import Payments from './payments.js'
import BooksyApp from './booksy-app.js'
import LoyaltyProgram from './loyalty-program.js'
import { ROUTE_META_PARAMS } from '@/router/consts.js'

export const SETTINGS_INVENTORY = 'settings-inventory'

const shouldOnlineBookingBeVisible = (store) => {
  const { identity, business } = store.state

  if ([ACCESS_LEVELS.MANAGER, ACCESS_LEVELS.OWNER].includes(identity.user.access_level)) {
    return true
  }

  if (business.business.is_visible_in_marketplace) {
    return true
  }

  return false
}

const shouldInventoryBeVisible = (store) => {
  if (store.state.routingConfig?.config?.inventory_settings_hidden) {
    return false
  }
  const { identity } = store.state

  return [ACCESS_LEVELS.RECEPTION, ACCESS_LEVELS.MANAGER, ACCESS_LEVELS.OWNER].includes(identity.user.access_level)
}

const beforeEnterBooksyPayActivationSplash = async (to, _from, next) => {
  if (to.params?.splashScreen !== SPLASH_SCREENS_VIEWS.BOOKSY_PAY_ACTIVATION) {
    next()
    return
  }

  const redirectRoute = await resolveBooksyPayEntryRedirect({
    targetView: BOOKSY_PAY_ENTRY_TARGETS.ACTIVATION,
    store,
    route: to,
  })

  if (redirectRoute) {
    return next(redirectRoute)
  }

  next()
}

export default {
  path: 'settings',
  name: 'settings',
  meta: {
    title: __t('routes.settings.title'),
    backgroundIcon: 'settings',
    useSmartlook: true,
  },
  component: () => import('@/views/business/settings/index.vue'),
  children: [
    Payments,
    Details,
    Services,
    AdvancedOptions,
    ...Subscription,
    Personal,
    PartnerApps,
    {
      path: 'online-booking',
      name: 'settings-online-booking',
      query: {
        [ONLINE_BOOKING_ENTRY_SOURCE_QUERY_KEY]: ONLINE_BOOKING_ENTRY_SOURCES.SETTINGS,
      },
      meta: {
        title: __t('routes.settings.online-booking.title'),
        subtitle: __t('routes.settings.online-booking.subtitle'),
        icon: 'online-booking',
        [ROUTE_META_PARAMS.SHOULD_BE_VISIBLE]: shouldOnlineBookingBeVisible,
        hintKey: 'hintFeatureOnlineBooking',
      },
      component: () => import('@/views/business/settings/online-booking/index.vue'),
    },
    {
      path: 'inventory',
      name: SETTINGS_INVENTORY,
      meta: {
        title: __t('routes.settings.inventory.title'),
        subtitle: __t('routes.settings.inventory.subtitle'),
        icon: 'inventory',
        [ROUTE_META_PARAMS.SHOULD_BE_VISIBLE]: shouldInventoryBeVisible,
      },
      component: () => import('@/views/business/settings/inventory/iframe-service.vue'),
    },
    {
      path: 'subscription-status/:type',
      name: 'settings-subscription-status',
      meta: {},
      component: () => import('@/views/business/settings/subscription/subscription-status.vue'),
    },
    {
      path: 'splash-screens/:splashScreen?',
      name: 'settings-splash-screens',
      beforeEnter: beforeEnterBooksyPayActivationSplash,
      meta: {
        fullWidth: true,
        [ROUTE_META_PARAMS.HIDDEN_IN_SEARCH]: true,
        [ROUTE_META_PARAMS.SHOULD_BE_VISIBLE]: () => false,
      },
      component: () => import('@/views/business/settings/splash-screens/index.vue'),
    },
    BooksyApp,
    LoyaltyProgram,
  ],
}
